export function formatMoney (value) {
  const num = Number(value)
  if (!Number.isFinite(num)) return '0.00'
  return num.toLocaleString('ko-KR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export function formatPointAmount (value) {
  const num = Number(value)
  if (!Number.isFinite(num)) return '0'
  return Math.floor(num).toLocaleString('ko-KR')
}

/** KRW → USDT (rate = KRW per 1 USDT) */
export function convertKrwToUsdt (krw, ratePerUsdt) {
  const amount = Number(krw)
  const rate = Number(ratePerUsdt)
  if (!Number.isFinite(amount) || amount <= 0) return null
  if (!Number.isFinite(rate) || rate <= 0) return null
  return amount / rate
}

export function formatUsdtAmount (value, { maxDecimals = 4, minDecimals = 2 } = {}) {
  const num = Number(value)
  if (!Number.isFinite(num)) return '0'
  return num.toLocaleString('ko-KR', {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals
  })
}

export function formatCurrencyAmount (value, currency = '₩') {
  const amount = formatMoney(value)
  const code = String(currency || '₩').trim() || '₩'
  if (code === '원') return `${amount}원`
  return `${code}${amount}`
}

export function formatBalance (value, currency = '₩') {
  return formatCurrencyAmount(value, currency)
}

/**
 * API UTC 시각 → 브라우저 로컬 Date
 * - 타임존 표기 없는 문자열(예: 2026-05-27 15:25:00)은 UTC로 해석
 */
export function parseUtcToLocalDate (value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  if (typeof value === 'number') {
    const ms = Math.abs(value) < 1e12 ? value * 1000 : value
    const date = new Date(ms)
    return Number.isNaN(date.getTime()) ? null : date
  }

  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  if (!trimmed) return null

  if (/^\d+$/.test(trimmed)) {
    const num = Number(trimmed)
    if (!Number.isFinite(num)) return null
    const ms = Math.abs(num) < 1e12 ? num * 1000 : num
    const date = new Date(ms)
    return Number.isNaN(date.getTime()) ? null : date
  }

  const hasTz = /(?:[zZ]|[+-]\d{2}:?\d{2})$/.test(trimmed)
  let normalized = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T')
  normalized = normalized.replace(/(\.\d{3})\d+/, '$1')

  if (!hasTz) {
    normalized = `${normalized}Z`
  }

  const date = new Date(normalized)
  if (Number.isNaN(date.getTime())) return null
  return date
}

function formatLocalDateParts (date, { withSeconds = false } = {}) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  const hh = String(date.getHours()).padStart(2, '0')
  const mm = String(date.getMinutes()).padStart(2, '0')
  if (!withSeconds) return `${y}-${m}-${d} ${hh}:${mm}`
  const ss = String(date.getSeconds()).padStart(2, '0')
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
}

/** API UTC → 로컬 시간 (기본: 분까지) */
export function formatDateTime (value, { withSeconds = false } = {}) {
  return formatUtcDateTime(value, { withSeconds })
}

/** API UTC → 로컬 시간 표시 */
export function formatUtcDateTime (value, { withSeconds = true } = {}) {
  const date = parseUtcToLocalDate(value)
  if (!date) return '-'
  return formatLocalDateParts(date, { withSeconds })
}

export function displayValue (value, emptyText = '-') {
  if (value === null || value === undefined) return emptyText
  const text = String(value).trim()
  return text || emptyText
}

/** 처리일시 유효 여부 (미처리·기본값 0001-01-01 등 제외) */
export function isValidProcDate (value) {
  if (value === null || value === undefined) return false
  const str = String(value).trim()
  if (!str || str === '0') return false
  if (/^000[01]-/.test(str)) return false
  const date = parseUtcToLocalDate(value)
  if (!date) return false
  return date.getFullYear() >= 1970
}

/** 입·출금 처리일시 (미완료·무효 날짜는 '-') */
export function formatWalletProcDate (value, { pending = false } = {}) {
  if (pending) return '-'
  if (!isValidProcDate(value)) return '-'
  return formatUtcDateTime(value)
}
